import React from 'react';
import axios from 'axios';
import { util } from '../config'
import qs from 'qs'
import '../style/giftPop.scss'
class GiftPop extends React.Component {
  constructor(props) {
    super();
    this.state = {
      step: 1,
      RewardSend: false
    }
  }

  getAreaName(areaid) {
    var areaname = "";
    if (areaid >= 500) {
      areaname = "苹果" + (areaid - 500) + "区";
    } else if (areaid >= 301 && areaid <= 306) {
      areaname = "腾讯" + (areaid - 300) + "区";
    } else {
      areaname = "安卓" + areaid + "区";
    }
    return areaname;
  }

  getReward = () => {
    const step = this.props.giftLevel;
    if (this.state.RewardSend) {
      return;
    }
    this.setState({ RewardSend: true })
    axios.post('https://actblood.web.sdo.com/Api/2020/1012/GetReward.ashx', qs.stringify({
      get: step
    })).then(res => {
      this.setState({ RewardSend: false })
      if (res.data.success) {
        this.props.updateLoadInfo()
        this.setState({ step: 2 })
      } else {
        util.showToast({ msg: res.data.msg })
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isGiftPopShow !== this.props.isGiftPopShow && this.props.isGiftPopShow) {
      this.setState({ step: 1 });
    }
  }

  render() {
    return (
      <div className="popup gift-pop">
        <div className="content">
          <div className="title"></div>
          <div className="step-container">
            <div className="step1" style={{ 'display': this.state.step === 1 ? 'block' : 'none' }}>
              <div className="title"></div>
              <p>本阶段奖励一经领取，将无法添加新角色账号进行再次领取，<br />请确是否以以下登记角色领取奖励</p>
              <ul className="account-list">
                {this.props.accountList.map(account => (
                  <li key={account.userid}><i></i><span className="area-name">{this.getAreaName(parseInt(account.areaid))}</span><span className="user-name">{account.name}</span></li>
                ))}
                {this.props.accountList.length < 5 && <li className="add-account-btn" onClick={this.props.goBind}></li>}
              </ul>
              <div className="btn-container">
                <div className="cancel-btn" onClick={this.props.toggleGiftPop}></div>
                <div className="comfirm-btn" onClick={this.getReward}></div>
              </div>
            </div>
            <div className="step2" style={{ 'display': this.state.step === 2 ? 'block' : 'none' }}>
              <div className="title"></div>
              <p>请登录游戏在邮箱中查看奖励</p>
            </div>
          </div>
          <div className="close" onClick={this.props.toggleGiftPop}></div>
        </div>
      </div>
    )
  }
}

export default GiftPop;
